<h1 mat-dialog-title class="p-2 text-center">Ajout d'un plan</h1>
<div mat-dialog-content class="p-3">

    <div class="row g-0 justify-content-center">
        <mat-form-field class="col">
            <mat-select placeholder="Selectionnez un plan" [(ngModel)]="this.AreaMap" (selectionChange)="onChange($event)">
                @for (m of AreaMapList; track m) {
                <mat-option [value]="m">
                    <span>{{m.Legend}} </span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    @if (MapFile) {
    <div>
        <img class="w-100" [src]="MapFile" alt="">
    </div>
    }
    <div class="row mt-3 g-0">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
            Annuler
        </button>
        <button appPreventDoubleClick class="col ms-1" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!CanAdd()">
            Ajouter
        </button>
    </div>
</div>